import {PureElementRule} from "../../slate/html/Html";
import {DeserializedElement, DeserializedElementRule} from "../../slate/Transformation";

let Ol = PureElementRule('ol', {
    tagType: 'block'
});
const des = Ol.deserialize;
Ol.deserialize = (el, next) => {
    let ol: DeserializedElement = des(el, next);
    if (ol) {
        ol.children = ol.children.filter((li) => li.type === "li");
    }
    return ol;
};

export const Rules: {[key: string]: DeserializedElementRule<HTMLElement>} = {
    "ol": Ol,
}